import api from "../../../api/comptabilite/_depot";

const state = () => ({
    liste_depots: [],
    depot_patient: [],
});

// getters
const getters = {
    liste_depots: (state) => {
        return state.liste_depots;
    },

    depot_patient: (state) => {
        return state.depot_patient;
    },
};
// mutations
const mutations = {
    SET_LISTE_DEPOTS(state, depot) {
        state.liste_depots = depot;
    },

    SET_DEPOT_PATIENT(state, depot) {
        state.depot_patient = depot;
    },
};

// actions
const actions = {

    getListeDepots({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeDepots(data).then(
                (response) => {
                    commit("SET_LISTE_DEPOTS", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    saveDepot({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveDepot(data).then(
                (response) => {
                    dispatch;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getDepotPatient({ commit }, patient_id) {
        return new Promise((resolve, reject) => {
            api.getDepotPatient(patient_id).then(
                (response) => {
                    commit("SET_DEPOT_PATIENT", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    payBackDepotPatient({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.payBackDepotPatient(data).then(
                (response) => {
                    dispatch;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

};

export default {
    state,
    getters,
    mutations,
    actions,
};